import {ConversationTeamStatusesEnum} from '../../../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {TicketStatusModel} from '../../../../../libs/shared/core/src/models/api/ticketStatusModel';
import {
  CellsContext,
  CellsContextTypesEnum,
} from '../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {
  ActivityModel,
  BasicActivityModel,
  BasicActivityReminderModel,
  BasicActivityTagModel,
} from '../../../../../src/models/api/activityModel';
import {ConversationBaseModel} from '../../../../../src/models/api/conversationModel';
import {ReminderModel} from '../../../../../src/models/api/reminderModel';

export enum StaticViewerActivityTypesEnum {
  REMINDER = 'REMINDER',
  OPEN = 'OPEN',
  ARCHIVED = 'ARCHIVED',
  TRASHED = 'TRASHED',
  TICKET_STATUS = 'TICKET_STATUS',
}

export interface StaticViewerActivityDetails {
  teammateName: string | undefined;
  date: number | undefined;
}

interface StaticViewerTicketStatusActivity {
  type: StaticViewerActivityTypesEnum.TICKET_STATUS;
  activity: BasicActivityTagModel | undefined;
}

interface StaticViewerReminderActivity {
  type: StaticViewerActivityTypesEnum.REMINDER;
  activity: BasicActivityReminderModel | undefined;
}

export type StaticViewerActivity =
  | StaticViewerReminderActivity
  | StaticViewerTicketStatusActivity
  | {
      type:
        | StaticViewerActivityTypesEnum.OPEN
        | StaticViewerActivityTypesEnum.ARCHIVED
        | StaticViewerActivityTypesEnum.TRASHED;
      activity: BasicActivityModel | undefined;
    };

export const computeStaticViewerActivityType = (
  conversation: ConversationBaseModel,
  ticketStatus: TicketStatusModel | undefined,
  teamReminder: ReminderModel | undefined,
  isConversationTicketingEnabled: boolean,
): StaticViewerActivityTypesEnum | undefined => {
  if (isConversationTicketingEnabled && ticketStatus) {
    return StaticViewerActivityTypesEnum.TICKET_STATUS;
  }

  if (teamReminder) {
    return StaticViewerActivityTypesEnum.REMINDER;
  }

  if (conversation.teamStatus === ConversationTeamStatusesEnum.OPEN) {
    return StaticViewerActivityTypesEnum.OPEN;
  }

  if (conversation.teamStatus === ConversationTeamStatusesEnum.ARCHIVED) {
    return StaticViewerActivityTypesEnum.ARCHIVED;
  }

  if (conversation.teamStatus === ConversationTeamStatusesEnum.TRASHED) {
    return StaticViewerActivityTypesEnum.TRASHED;
  }

  return undefined;
};

/** Filters the array of activities from the timeline as to remove the last activity of the list if it's responsible for a StaticViewer being shown. */
export function filterStaticViewerBannerActivity(
  cellsContext: CellsContext,
  staticViewerActivity: StaticViewerActivity | undefined,
  activity: ActivityModel,
  index: number,
  array: ReadonlyArray<ActivityModel>,
) {
  // If there is no static viewer activity, nothing to do.
  if (!staticViewerActivity) {
    return true;
  }

  // If our conversation is not in a teammate context, nothing to do.
  if (cellsContext.type !== CellsContextTypesEnum.TEAMMATE) {
    return true;
  }

  // If our activity isn't the last, nothing to do.
  if (index < array.length - 1) {
    return true;
  }

  return staticViewerActivity.activity?.id !== activity.id;
}
